import {
  Component,
  EventEmitter,
  Input,
  OnInit,
  Output,
  ViewEncapsulation
} from '@angular/core';
import { UntypedFormGroup } from '@angular/forms';
import { RecoveryOptionsContent } from './models/recovery-options.interface';

@Component({
  selector: 'idp-recovery-options',
  templateUrl: './recovery-options.component.html',
  styleUrls: ['./recovery-options.component.scss'],
  encapsulation: ViewEncapsulation.None
})
export class RecoveryOptionsComponent implements OnInit {
  @Input() content: RecoveryOptionsContent = {} as RecoveryOptionsContent;
  @Input() machCore = false;
  recoveryOptionsForm!: UntypedFormGroup;
  @Output() closeOverlayMessage: EventEmitter<boolean> =
    new EventEmitter<boolean>();

  @Output() formSubmitEvent: EventEmitter<string> = new EventEmitter<string>();
  @Output() triggerClose = new EventEmitter();

  ngOnInit(): void {
    this.recoveryOptionsForm = this.content.formGroup as UntypedFormGroup;
  }

  closePopup() {
    this.closeOverlayMessage.emit(false);
  }

  onSubmit() {
    this.formSubmitEvent.emit();
  }
}
